function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import withStyles from 'isomorphic-style-loader/withStyles';
import { FormattedMessage } from 'react-intl';
import moment from 'moment';
import PropTypes from 'prop-types';
import AverageBlood from 'svg/average-blood.svg';
import ReadingFlagIcon from 'components/ReadingFlagIcon';
import Polygon from 'svg/polygon.svg';
import * as shapes from '../../shapes';
import messages from '../../messages';
import styles from './ReadingTooltip.pcss';
var _React_PureComponent;
class ReadingTooltip extends (_React_PureComponent = React.PureComponent) {
    renderTitle() {
        return /*#__PURE__*/ _jsxs("div", {
            className: styles.readingTooltip__title,
            children: [
                /*#__PURE__*/ _jsx(AverageBlood, {
                    className: styles.readingTooltip__titleIcon
                }),
                /*#__PURE__*/ _jsx("div", {
                    className: styles.readingTooltip__resultText,
                    children: /*#__PURE__*/ _jsx(FormattedMessage, _object_spread({}, messages.headers.measurement))
                })
            ]
        });
    }
    renderContent() {
        const { reading, conversion } = this.props;
        const { displayValue, timestamp, flag, type } = reading;
        const measurementTypeClass = styles[`readingTooltip__resultIcon--${type}`];
        const formattedDatetime = moment.unix(timestamp).utc().format('LT');
        return /*#__PURE__*/ _jsxs("div", {
            className: styles.readingTooltip__result,
            children: [
                /*#__PURE__*/ _jsx(ReadingFlagIcon, {
                    className: `${styles.readingTooltip__resultIcon} ${measurementTypeClass}`,
                    flag: flag
                }),
                /*#__PURE__*/ _jsx("div", {
                    className: styles.readingTooltip__resultText,
                    children: `${displayValue} ${conversion.unitSymbol}`
                }),
                /*#__PURE__*/ _jsx("div", {
                    className: styles.readingTooltip__datetime,
                    children: formattedDatetime
                })
            ]
        });
    }
    render() {
        return /*#__PURE__*/ _jsxs("div", {
            className: styles.readingTooltip,
            children: [
                this.renderTitle(),
                /*#__PURE__*/ _jsx("div", {
                    className: styles.readingTooltip__separator
                }),
                /*#__PURE__*/ _jsxs("div", {
                    className: styles.readingTooltip__content,
                    children: [
                        this.renderContent(),
                        /*#__PURE__*/ _jsx(Polygon, {
                            width: "17",
                            height: "12",
                            className: styles.readingTooltip__polygon
                        })
                    ]
                })
            ]
        });
    }
}
_define_property(ReadingTooltip, "propTypes", {
    // Explicit props
    reading: shapes.reading.isRequired,
    conversion: PropTypes.object.isRequired
});
export default withStyles(styles)(ReadingTooltip);
